  <template>
    <div id="shareWidget" class="share-widget" v-if="loaded">
      <transition name="share-widget__share-animation">
        <div id="shareView" class="share-view share-widget__share" v-if="showShareBox">
            <ShareBox
              :shareUrl="urlShare"
              :shareTitle="titleShare"
              :shareHashtags="twitterHashTag"
              :shareQuote="quoteShare"
            />
        </div>
      </transition>
    </div>
  </template>


  <script>
  import ShareBox from '@components/ShareBox'
  export default {
    components: {
      ShareBox
    },
    data () {
      return {
        showShareBox: false,
        loaded: false,
        twitterHashTag: window.twitterHashtag
          ? window.twitterHashtag
          : 'Dixit Today',
        urlShare: window.urlShare
          ? window.urlShare
          : 'http://google.be',
        titleShare: window.titleShare
          ? window.titleShare
          : 'Title sharing ',
        quoteShare: window.quoteShare
          ? window.quoteShare
          : 'tagline',
        isPrivate: window.isPrivate
          ? window.isPrivate
          : false,
           positionLeftShareButton: window.positionLeftShareButton
          ? window.positionLeftShareButton
          : false
      }
    },
    computed: {},
    created () {
      this.loaded = true
    },
    methods: {
      storeData () {
        this.twitterHashTag =  window.twitterHashtag
        this.urlShare =  window.urlShare
        this.titleShare =  window.titleShare
        this.quoteShare =  window.quoteShare
        this.isPrivate =  window.isPrivate
        this.positionLeftShareButton =  window.positionLeftShareButton
        this.showShareBox = true
      }
      
    }
  }

  </script>

  <style lang="scss">
  @import "@/assets/styles/main/main.scss";

  .button-share {
    cursor:pointer;
  }
  .share-widget {
        box-sizing: border-box;
        z-index: 10000;
        position: absolute;
        display: table;
        width: 100%;
    &__share {

      &-animation-enter,
      &-animation-leave-to {
        opacity: 0;
        transform: translateY(30px);
      }
      &-animation-leave-active{
          transition: all 0.5s;
      }
      &-animation-enter-active {
        transition: all 0.5s;
        transition-delay: 0.5s;
      }
    }
  }
  </style>
}
